<template>
  <!-- Floating Button (desktop only) -->
  <div class="coffee-floating-button" @click="showModal = true">
    <span>☕</span>
    <div class="tooltip">Donate</div>
  </div>

  <!-- Donation Modal -->
  <div v-if="showModal" class="modal">
    <div class="modal-content">
      <h2>Support our work!</h2>
      <p>
        Thank you for supporting our project! Click the button below to buy us a coffee.
      </p>
      <a
        href="https://buymeacoffee.com/foodplanner"
        target="_blank"
        rel="noopener noreferrer"
        class="donation-button"
      >
        Buy Me a Coffee
      </a>
      <button class="cancel-button" @click="showModal = false">
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingCoffeeButton",
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
  },
  mounted() {
    // Listen for the custom event triggered by the navbar menu item
    window.addEventListener("open-donation-modal", this.openModal);
  },
  beforeUnmount() {
    window.removeEventListener("open-donation-modal", this.openModal);
  },
};
</script>

<style scoped>
/* Desktop style for the floating coffee button */
.coffee-floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #ffc107;
  color: #333;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Tooltip (desktop only) */
.tooltip {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.2s linear;
  position: absolute;
  bottom: 60px;
  background-color: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
}

.coffee-floating-button:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

/* Modal styles */
/* Modal background overlay */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000;
}

/* Modal content styling */
.modal-content {
  background: #1e1e1e;
  color: #fff;
  padding: 25px 35px;
  border-radius: 10px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.8);
  transition: transform 0.3s ease;
}

/* Header styling */
.modal-content h2 {
  margin-bottom: 15px;
  color: #ffc107;
  font-size: 1.5rem;
}

/* Paragraph styling */
.modal-content p {
  margin-bottom: 20px;
  line-height: 1.4;
}

/* Donation button styling */
.donation-button {
  background-color: #ffc107;
  color: #1e1e1e;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: bold;
  display: inline-block;
  transition: background-color 0.3s ease;
}

.donation-button:hover {
  background-color: #e0a600;
}

/* Cancel/Close button styling */
.cancel-button {
  margin-top: 20px;
  background-color: #dc3545;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cancel-button:hover {
  background-color: #b52e3a;
}

/* Mobile-specific adjustments: hide the floating button */
@media (max-width: 600px) {
  .coffee-floating-button {
    display: none;
  }
  .tooltip {
    display: none;
  }
}
</style>
